import { TCommonWizardsSchema } from "../api/hooks/use-deal-request";
import { IFacilityTypeSchema } from "../api/hooks/use-facility-type";
import { ESpecificsOfSale } from "../components/shared/wizard/steps/types";
import { IButtonCard } from "../components/ui/button/buttonCard";
import { ISelectItem } from "../components/ui/select";
import { RUBLE_SIGN } from "./constants";
import {
  AttachmentSchema,
  FacilityPlanSchema,
  FacilityReportResponseWrapper,
} from "../api/hooks/hooks-reit-facility/types";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { IImage } from "../components/ui/imgGallery";

export const toReadableNumber = (num: number | string, delim = " ") => {
  return num
    ?.toString()
    .split("")
    .reverse()
    .reduce((acc, curr, i) => {
      if (i !== 0 && i % 3 === 0) {
        return curr + delim + acc;
      }

      return curr + acc;
    }, "");
};

export const toReadablePrice = (num: number | string) => {
  return toReadableNumber(num) + " " + RUBLE_SIGN;
};

export const toPercent = (num: number) => {
  return `${num} %`;
};

export const transformPhone = (phone: string) => {
  return phone.replaceAll(" ", "");
};

interface ISortInterfaceByTitle {
  label: string;
  [key: string]: any;
}

export const sortByTitle = (arr: ISortInterfaceByTitle[]) => {
  return arr.sort(customSort);

  function customSort(a: ISortInterfaceByTitle, b: ISortInterfaceByTitle) {
    const titleA = a.label;
    const titleB = b.label;

    // Паттерн для проверки, начинается ли строка с цифры
    const isNumericA = /^\d/.test(titleA);
    const isNumericB = /^\d/.test(titleB);

    // Если оба заголовка являются строками, начинающимися с букв
    if (!isNumericA && !isNumericB) {
      return titleA.localeCompare(titleB, "ru");
    }

    // Если один заголовок строка, а другой - число
    if (isNumericA && !isNumericB) {
      return 1; // Числа идут после строк
    }
    if (!isNumericA && isNumericB) {
      return -1; // Строки идут перед числами
    }

    // Если оба заголовка - числа, сравниваем их как числа
    const numA = titleA.match(/^\d+/)
      ? parseInt(titleA.match(/^\d+/)![0])
      : titleA;
    const numB = titleB.match(/^\d+/)
      ? parseInt(titleB.match(/^\d+/)![0])
      : titleB;

    if (numA !== numB) {
      return Number(numA) - Number(numB);
    }

    // Если числа равны, сортируем по полному заголовку
    return titleA.localeCompare(titleB, "ru");
  }
};

export const getTransformedMinMaxMarketPrice = (price: string) => {
  if (price.length < 7) {
    return 0 + "." + String(price)[0] + " " + "млн" + ` ${RUBLE_SIGN}`;
  }

  if (price.length === 9) {
    return (
      String(price)[0] +
      String(price)[1] +
      String(price)[2] +
      +"." +
      String(price)[3] +
      " " +
      " млн" +
      ` ${RUBLE_SIGN}`
    );
  }

  if (price.length === 8) {
    return (
      String(price)[0] +
      String(price)[1] +
      "." +
      String(price)[2] +
      " " +
      "млн" +
      ` ${RUBLE_SIGN}`
    );
  }

  return (
    String(price)[0] + "." + String(price)[1] + " " + "млн" + ` ${RUBLE_SIGN}`
  );
};

///// facilityType  /////

export const descriptionFacilityTypeList = [
  {
    id: 1,
    img: { url: "../img/plans/1-k-studia.jpg", alt: "1-k-studia" },
    description:
      "1-комнатная студия — квартира, где кухня и гостиная объединены в одно пространство, без перегородок. Такая планировка подойдет для тех, кто ценит минимализм и функциональность, даже на небольшой площади.",
    connection: [8, 2],
    pair: 8,
  },
  {
    id: 2,
    img: { url: "../img/plans/2-k-studia.jpg", alt: "2-k-studia" },
    description:
      "2-комнатная квартира-студия — это квартира совмещённой гостиной и кухней, либо кухней-нишей и отдельной спальней. Площадь кухни-гостиной, обычно более 14м2.",
    connection: [8, 9],
    pair: 9,
  },
  {
    id: 3,
    img: { url: "../img/plans/3-k-studia.jpg", alt: "3-k-studia" },
    description:
      "3-комнатная студия -  это современное сочетание открытого пространства кухни-гостиной обычно более 14м2 и двух изолированных комнат. Такая планировка обеспечивает простор для семейных вечеров и встреч с друзьями, а также позволяет сохранить уединение в личных зонах.",
    connection: [9, 10],
    pair: 10,
  },
  {
    id: 4,
    img: { url: "../img/plans/4-k-studia.jpg", alt: "4-k-studia" },
    description:
      "4-комнатная студия – квартира, где кухня объединена с гостиной, создавая уютное пространство для отдыха и общения. Три изолированные спальни, обычно два санузла, гардеробная.",
    connection: [10, 11],
    pair: 11,
  },
  {
    id: 8,
    img: { url: "../img/plans/1-k.jpg", alt: "1-k" },
    description:
      " 1-комнатная квартира - это классическое решение с отдельной жилой комнатой, кухней, санузлом и прихожей. Такая планировка позволяет организовать пространство сохраняя приватность благодаря разделению зон.",
    connection: [1, 2],
    pair: 1,
  },
  {
    id: 9,
    img: { url: "../img/plans/2-k.jpg", alt: "2-k" },
    description:
      "2-комнатная квартира – это квартира двумя изолированными комнатами, кухней, прихожей и санузлом. В Квартире можно обустроить спальню, гостиную или кабинет, сохраняя комфорт и функциональность.",
    connection: [2, 3],
    pair: 2,
  },
  {
    id: 10,
    img: { url: "../img/plans/3-k.jpg", alt: "3-k" },
    description:
      "3-комнатная квартира - просторное жильё для большой семьи или людей, которым важно иметь несколько отдельных зон для отдыха, работы и общения. Три комнаты позволяют создать устроить личное пространство для каждого члена семьи.",
    connection: [3, 4],
    pair: 3,
  },
  {
    id: 11,
    img: { url: "../img/plans/4-k.jpg", alt: "4-k" },
    description:
      "4-комнатная квартира – просторная квартира  для большой семьи, обеспечивая отдельные зоны для отдыха, работы и общения. Каждый член семьи получит личное пространство. ",
    connection: [3, 4],
    pair: 4,
  },
  {
    id: 17,
    img: { url: "../img/plans/5-k.jpg", alt: "5-k" },
    description:
      "Многокомнатная квартира – квартира, в которой больше чем три изолированных комнаты.",
    connection: [4, 11],
    pair: null,
  },
];

const facilityTypeMethods = {
  findOnTypeList: (selected: ISelectItem) =>
    descriptionFacilityTypeList.find((type) => type.id === selected.key),
  filteredOnTypeListById: (
    selectedType: (typeof descriptionFacilityTypeList)[number],
    isPair: boolean | undefined,
    facilityTypeList: IFacilityTypeSchema[]
  ) =>
    facilityTypeList.filter(
      (facilityType) =>
        facilityType.id === selectedType.id ||
        (isPair && facilityType.id === selectedType.pair)
    ),
  mapOnTypeList: (
    selectedFiltered: IFacilityTypeSchema[],
    data: number[] | null,
    onChange: ((value: number) => void) | undefined
  ) =>
    selectedFiltered.map((type) => {
      return {
        img: descriptionFacilityTypeList.find((type2) => type2.id === type.id)
          ?.img,
        label: type.fullTitle,
        id: type.id,
        text: descriptionFacilityTypeList.find((type2) => type2.id === type.id)
          ?.description,
        isSelected: data?.includes(type.id),
        onChange: () => (onChange ? onChange(type.id) : undefined),
      };
    }),
  filteredOnTypeListByConnections: (
    selectedType: (typeof descriptionFacilityTypeList)[number],
    facilityTypeList: IFacilityTypeSchema[]
  ) =>
    facilityTypeList.filter((plan) => {
      return selectedType?.connection.includes(plan.id);
    }),
};

export function getFacilityTypes(
  selected: ISelectItem,
  data: number[] | null,
  facilityTypeList: IFacilityTypeSchema[],
  isPair?: boolean,
  onChange?: (value: number) => void
) {
  const selectedType = facilityTypeMethods.findOnTypeList(selected);

  if (selectedType) {
    const selectedFiltered = facilityTypeMethods.filteredOnTypeListById(
      selectedType,
      isPair,
      facilityTypeList
    );

    return facilityTypeMethods.mapOnTypeList(
      selectedFiltered,
      data,
      onChange
    ) as IButtonCard[] | undefined;
  }
}

export function getFacilityTypesConnection(
  selected: ISelectItem,
  data: number[] | null,
  facilityTypeList: IFacilityTypeSchema[],
  onChange?: (value: number) => void
) {
  const selectedType = facilityTypeMethods.findOnTypeList(selected);

  if (selectedType) {
    const selectedFiltered =
      facilityTypeMethods.filteredOnTypeListByConnections(
        selectedType,
        facilityTypeList
      );

    return facilityTypeMethods.mapOnTypeList(
      selectedFiltered,
      data,
      onChange
    ) as IButtonCard[] | undefined;
  }
}

export const getSpecificsOfSale = (
  data: TCommonWizardsSchema
): ESpecificsOfSale[] | undefined => {
  const valuesESpecificsOfSale = Object.keys(ESpecificsOfSale);

  const valuesOfEnum = Object.entries(data)
    .map(([key, value]) => {
      if (valuesESpecificsOfSale.includes(key) && value === true) {
        return ESpecificsOfSale[key as keyof typeof ESpecificsOfSale];
      }
    })
    .filter((value) => value !== undefined);

  return (valuesOfEnum.length ? valuesOfEnum : undefined) as
    | ESpecificsOfSale[]
    | undefined;
};

export enum DateFormat {
  day = "day",
  quarter = "quarter",
  year = "year",
}

export const UTCtoLocal = (date: string, type?: DateFormat): string => {
  if (isNaN(Date.parse(date))) return date;
  const romeNumbers = new Map([
    [1, "I"],
    [2, "II"],
    [3, "III"],
    [4, "IV"],
  ]);
  if (type === DateFormat.day) return moment(date).format("DD.MM.YYYY");
  if (type === DateFormat.quarter)
    return `${romeNumbers.get(moment(date).quarter())} квартал ${moment(
      date
    ).year()}`;

  if (type === DateFormat.year) {
    return moment(date).year().toString();
  }

  return moment(date).format("DD.MM.YYYY HH:mm");
};

export function getImgFromObjectFacility(data: {
  plan?: FacilityPlanSchema;
  media?: AttachmentSchema[];
  [key: string]: any;
}) {
  const media = data?.media
    ? data?.media
        .map((mediaItem) => {
          return {
            src: mediaItem?.url,
            alt: mediaItem.name,
          };
        })
        .filter((item) => item.src !== undefined)
    : [];

  const plan = { src: data?.plan?.media?.url, alt: data?.plan?.media?.name };

  if (plan.src && media) {
    return [plan, ...media] as IImage[];
  }

  if (media) {
    return media as IImage[];
  }

  if (plan.src) {
    return [plan] as IImage[];
  }

  return [];
}

export const downloadFacilityReport = async (
  request: () => Promise<FacilityReportResponseWrapper>,
  facilityTitle: string
) => {
  return new Promise((resolve) => {
    request()
      .then((data) => {
        const link = document.createElement("a");
        link.href = data.data;
        link.setAttribute(
          "download",
          `${facilityTitle} ${moment
            .tz("Asia/Krasnoyarsk")
            .format("DD.MM.YYYY / HH:mm")}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => toast.error("Ошибка при формировании отчета"))
      .finally(() => resolve(true));
  });
};

function levenshteinDistance(str1: string, str2: string) {
  const matrix = [];

  for (let i = 0; i <= str1.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= str2.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= str1.length; i++) {
    for (let j = 1; j <= str2.length; j++) {
      const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }

  return matrix[str1.length][str2.length];
}

export function searchInputHelper(
  items: ISelectItem[],
  searchTerm: string,
  maxDistance = 6
) {
  const results = [];
  const lowerSearchTerm = searchTerm.toLowerCase();

  for (const item of items) {
    const lowerName = (item.label as string).toLowerCase();
    const distance = levenshteinDistance(lowerSearchTerm, lowerName);

    if (distance <= maxDistance) {
      results.push({
        item: item,
        distance: distance,
      });
    }
  }

  results.sort((a, b) => a.distance - b.distance);

  return results.map((result) => result.item);
}
